import axios from "axios";
export default {
  state: {
    user: [],
  },
  getters: {
    getter_user(state) {
      return state.user;
    },
  },
  mutations: {
    get_user(state, user) {
      state.user = user;
      return state.user;
    },
  },
  actions: {
    get_user(context) {
      axios.defaults.baseURL = process.env.VUE_APP_API_URL;
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.getters["auth/token"];
      if (context.getters["auth/loggedIn"]) {
        return new Promise((resolve, reject) => {
          axios
            .get("/user/1")
            .then((response) => {
              var userInfo = {
                displayName: response.data.user.name,
                about: "",
              };
              localStorage.setItem("userInfo", JSON.stringify(userInfo));
              if (response.data.success) {
                context.commit("get_user", response.data.user);
                resolve(response.data.user);
              } else {
                reject(response.data.message);
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
      }
    },
    save_user(context, user) {
      axios.defaults.baseURL = process.env.VUE_APP_API_URL;
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + context.getters["auth/token"];
      if (context.getters["auth/loggedIn"]) {
        return new Promise((resolve, reject) => {
          axios
            .put("/user/" + user.id, {
              name: user.name,
              password: user.password,
              password2: user.password2,
              abonado: user.abonado,
              telefono: user.telefono,
              masinfo: user.masinfo,
              nif: user.nif,
              merchant_identifier: user.merchant_identifier,
              paygold_expiry_date: user.paygold_expiry_date,
            })
            .then((response) => {
              if (response.data.success) {
                context.commit("get_user", response.data.user);
                resolve(response.data.message);
              } else {
                reject(response.data.message);
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
      }
    },
  },
};
